import React from "react";
import { Icon, PlainButton } from "@culturehq/components";

import { t, Trans } from "app/utils";
import ChqModalConfirmDelete from "components/common/ChqModalConfirmDelete";

const SurveyItemResponseOption = ({ onDelete, responseOption }) => {
  const onAccept = () => onDelete(responseOption);

  return (
    <div className="row chart-row" data-id={responseOption.id || responseOption.key}>
      <div className="col-sm-1">
        <div className="sortable__drag-handler" />
      </div>
      <div className="col-sm-7">{responseOption.body}</div>
      <div className="col-sm-4">
        <ChqModalConfirmDelete
          onAccept={onAccept}
          trigger={onTrigger => (
            <PlainButton aria-label={`${t("Delete")} ${responseOption.body} ${t("option")}`} className="link action pull-right" onClick={onTrigger}>
              <Icon icon="trash-a" /> <Trans>Delete</Trans>
            </PlainButton>
          )}
        >
          <Trans>Are you sure you want to delete this option?</Trans>
        </ChqModalConfirmDelete>
      </div>
    </div>
  );
};

export default SurveyItemResponseOption;
